import { render, staticRenderFns } from "./communityManageList.vue?vue&type=template&id=3df0bbca&scoped=true"
import script from "./communityManageList.vue?vue&type=script&lang=js"
export * from "./communityManageList.vue?vue&type=script&lang=js"
import style0 from "./communityManageList.vue?vue&type=style&index=0&id=3df0bbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0bbca",
  null
  
)

export default component.exports